/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type WorkOrderAssigneesQueryVariables = Types.Exact<{
  crudRights:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input']
  cruRights:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input']
}>

export type WorkOrderAssigneesQuery = {
  __typename?: 'Query'
  crudAssignees: Array<
    | {
        __typename?: 'BackofficeUser'
        id: string
        firstName: string
        lastName: string
      }
    | {
        __typename?: 'BackofficeUserLimited'
        id: string
        firstName: string
        lastName: string
      }
  > | null
  cruAssignees: Array<
    | {
        __typename?: 'BackofficeUser'
        id: string
        firstName: string
        lastName: string
      }
    | {
        __typename?: 'BackofficeUserLimited'
        id: string
        firstName: string
        lastName: string
      }
  > | null
}

export const WorkOrderAssigneesDocument = gql`
    query WorkOrderAssignees($crudRights: [String!]!, $cruRights: [String!]!) {
  crudAssignees: backofficeUsersByRights(rights: $crudRights) {
    ... on BackofficeUser {
      id
      firstName
      lastName
    }
    ... on BackofficeUserLimited {
      id
      firstName
      lastName
    }
  }
  cruAssignees: backofficeUsersByRights(rights: $cruRights) {
    ... on BackofficeUser {
      id
      firstName
      lastName
    }
    ... on BackofficeUserLimited {
      id
      firstName
      lastName
    }
  }
}
    `

/**
 * __useWorkOrderAssigneesQuery__
 *
 * To run a query within a React component, call `useWorkOrderAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderAssigneesQuery({
 *   variables: {
 *      crudRights: // value for 'crudRights'
 *      cruRights: // value for 'cruRights'
 *   },
 * });
 */
export function useWorkOrderAssigneesQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkOrderAssigneesQuery,
    WorkOrderAssigneesQueryVariables
  > &
    (
      | { variables: WorkOrderAssigneesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    WorkOrderAssigneesQuery,
    WorkOrderAssigneesQueryVariables
  >(WorkOrderAssigneesDocument, options)
}
export function useWorkOrderAssigneesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkOrderAssigneesQuery,
    WorkOrderAssigneesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    WorkOrderAssigneesQuery,
    WorkOrderAssigneesQueryVariables
  >(WorkOrderAssigneesDocument, options)
}
// @ts-ignore
export function useWorkOrderAssigneesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkOrderAssigneesQuery,
    WorkOrderAssigneesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkOrderAssigneesQuery,
  WorkOrderAssigneesQueryVariables
>
export function useWorkOrderAssigneesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrderAssigneesQuery,
        WorkOrderAssigneesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkOrderAssigneesQuery | undefined,
  WorkOrderAssigneesQueryVariables
>
export function useWorkOrderAssigneesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrderAssigneesQuery,
        WorkOrderAssigneesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    WorkOrderAssigneesQuery,
    WorkOrderAssigneesQueryVariables
  >(WorkOrderAssigneesDocument, options)
}
export type WorkOrderAssigneesQueryHookResult = ReturnType<
  typeof useWorkOrderAssigneesQuery
>
export type WorkOrderAssigneesLazyQueryHookResult = ReturnType<
  typeof useWorkOrderAssigneesLazyQuery
>
export type WorkOrderAssigneesSuspenseQueryHookResult = ReturnType<
  typeof useWorkOrderAssigneesSuspenseQuery
>
export type WorkOrderAssigneesQueryResult = Apollo.QueryResult<
  WorkOrderAssigneesQuery,
  WorkOrderAssigneesQueryVariables
>
